/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRoleDto } from '../../models/user-role-dto';

export interface UserRolesGet$Params {
  id: number;
}

export function userRolesGet(http: HttpClient, rootUrl: string, params: UserRolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRoleDto>> {
  const rb = new RequestBuilder(rootUrl, userRolesGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRoleDto>;
    })
  );
}

userRolesGet.PATH = '/user-roles/{id}';
